import { Badge } from "@f2e/ui/components/base"

import type { NotificationDestination } from "@/hooks/api/notifications"

export interface DestinationStatusBadgeProps {
  destination: NotificationDestination
  readyLabel: string
  pendingLabel: string
  disabledLabel: string
  verificationPendingLabel?: string
  verificationExpiredLabel?: string
}

export const DestinationStatusBadge = ({
  destination,
  readyLabel,
  pendingLabel,
  disabledLabel,
  verificationPendingLabel = pendingLabel,
  verificationExpiredLabel = pendingLabel,
}: DestinationStatusBadgeProps) => {
  if (!destination.isEnabled) {
    return (
      <Badge
        variant="outline"
        className="border-red-200 bg-red-50 font-medium text-red-700 dark:border-red-800 dark:bg-red-950/40 dark:text-red-300"
      >
        {disabledLabel}
      </Badge>
    )
  }
  if (!destination.isReady) {
    const unavailableLabel =
      destination.destinationType === "email"
        ? destination.verificationStatus === "expired"
          ? verificationExpiredLabel
          : verificationPendingLabel
        : pendingLabel
    return (
      <Badge
        variant="outline"
        className="border-amber-200 bg-amber-50 font-medium text-amber-800 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-200"
      >
        {unavailableLabel}
      </Badge>
    )
  }
  return (
    <Badge
      variant="outline"
      className="border-green-200 bg-green-50 font-medium text-green-700 dark:border-green-800 dark:bg-green-950/40 dark:text-green-300"
    >
      {readyLabel}
    </Badge>
  )
}
